import React from 'react';
import {Prism as SyntaxHighlighter} from 'react-syntax-highlighter';
import {prism} from 'react-syntax-highlighter/dist/esm/styles/prism';

const GetTaskStatus = ({ onSectionChange }) => {
    return (
        <div className="api-reference-layout">
            <div className="api-content">
                <div className="api-header">
                    <div className="api-method-badge get">GET</div>
                    <h1>get_task_status - Get Task Status</h1>
                    <p className="api-description">
                        Get the processing status of a memory task
                    </p>
                </div>

                <div className="api-endpoint">
                    <div className="endpoint-url">
                        <span className="method get">GET</span>
                        <span className="url">/api/v2/memory/memorize/status/&#123;task_id&#125;</span>
                    </div>
                </div>

                <div className="api-section">
                    <h2>Authorization</h2>
                    <div className="auth-item">
                        <div className="auth-header">
                            <span className="auth-name">Authorization</span>
                            <span className="auth-type">string</span>
                            <span className="auth-location">header</span>
                            <span className="required-badge">required</span>
                        </div>
                        <p>Bearer authentication header of the form Bearer &lt;token&gt;, where &lt;token&gt; is your API key.</p>
                    </div>
                </div>

                <div className="api-section">
                    <h2>Path Parameters</h2>
                    <div className="params-container">
                        <div className="param-item">
                            <div className="param-header">
                                <span className="param-name">task_id</span>
                                <span className="param-type">string</span>
                                <span className="required-badge">required</span>
                            </div>
                            <p>Task ID returned from memorize_conversation</p>
                            <div className="param-example">
                                <strong>Example:</strong>
                                <code>"task_abc123def456"</code>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="api-section">
                    <h2>Response</h2>
                    <div className="response-status">
                        <span className="status-code success">200</span>
                        <span className="content-type">application/json</span>
                    </div>

                    <div className="params-container">
                        <div className="param-item">
                            <div className="param-header">
                                <span className="param-name">task_id</span>
                                <span className="param-type">string</span>
                            </div>
                            <p>Unique identifier for the task</p>
                        </div>

                        <div className="param-divider"></div>

                        <div className="param-item">
                            <div className="param-header">
                                <span className="param-name">status</span>
                                <span className="param-type">string</span>
                            </div>
                            <p>Task status (PENDING/SUCCESS/FAILURE/REVOKED)</p>
                        </div>

                        <div className="param-divider"></div>

                        <div className="param-item">
                            <div className="param-header">
                                <span className="param-name">detail_info</span>
                                <span className="param-type">string</span>
                            </div>
                            <p>Detailed information or error description</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="api-demo-sidebar">
                <div className="demo-sticky">
                    <div className="demo-header">
                        <div className="demo-tabs">
                            <button className="demo-tab active">Python</button>
                            <button className="demo-tab">JavaScript</button>
                            <button className="demo-tab">cURL</button>
                        </div>
                    </div>

                    <div className="demo-content">
                        <SyntaxHighlighter
                            language="python"
                            style={prism}
                            customStyle={{
                                margin: 0,
                                padding: '20px',
                                background: 'white',
                                fontSize: '14px',
                                lineHeight: '1.5',
                                borderRadius: '0 0 8px 8px',
                                border: '1px solid #e5e7eb'
                            }}
                        >
                            {`import os
import time
from memu import MemuClient

# Initialize MemU client
memu_client = MemuClient(
    base_url="https://api.memu.so",
    api_key=os.getenv("MEMU_API_KEY")
)

# Task ID from memorize_conversation response
task_id = "task_abc123def456"

# Get task status
response = memu_client.get_task_status(task_id=task_id)

print(f"Task Status: {response.status}")
print(f"Details: {response.detail_info}")`}
                        </SyntaxHighlighter>
                    </div>

                    <div className="response-section">
                        <div className="response-header">
                            <span className="response-status-code">200</span>
                            <span>Response</span>
                        </div>
                        <SyntaxHighlighter
                            language="json"
                            style={prism}
                            customStyle={{
                                margin: 0,
                                padding: '20px',
                                background: 'white',
                                fontSize: '14px',
                                lineHeight: '1.5',
                                borderRadius: '0 0 8px 8px',
                                border: '1px solid #e5e7eb'
                            }}
                        >
                            {`{
  "task_id": "task_abc123def456",
  "status": "SUCCESS"
}`}
                        </SyntaxHighlighter>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default GetTaskStatus;